import { createSlice } from '@reduxjs/toolkit';
import { logger } from '../../helpers/logger';

const initialState = {};

const slice = createSlice({
    name: 'componentErrors',
    initialState,
    reducers: {
        setComponentError(state, action) {
            const { componentId, description, errorObject } = action.payload;
            state[componentId] = { description, errorObject };
        },
        clearComponentError(state, action) {
            const { componentId } = action.payload;
            delete state[componentId];
        },
        clearComponentErrors(state, action) {
            const { componentIds } = action.payload;
            if (Array.isArray(componentIds)) {
                componentIds.forEach((id) => {
                    delete state[id];
                });
            } else {
                logger.warn('clearComponentErrors expects an array of component IDs.');
            }
        },
    },
});

export const { setComponentError, clearComponentError, clearComponentErrors } = slice.actions;
export const general = { reducer: slice.reducer, initialState };
export default general;
